import { render, staticRenderFns } from "./ShowClient.vue?vue&type=template&id=1414fd7c&"
import script from "./ShowClient.vue?vue&type=script&lang=ts&"
export * from "./ShowClient.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports